
<p class="recent-label"><span class="material-icons">schedule</span> Most Recent</p>
<!--p *ngFor="let item of items">
<anms-menu-item [item]=item></anms-menu-item>
</p-->
@if (items$ | async; as items1) {
  @for (item1 of items1; track item1) {
    <p>
      <anms-menu-item (clickMenuEvent)="onClickMenu($event)" [item]=item1></anms-menu-item>
    </p>
  }
}


